import appConst from "./appConst.json"

export type DropDownOptionValue = string | number | undefined

export const normalizeToNumber = (value?: DropDownOptionValue) => {
  if (typeof value === "number") {
    return value
  }
  if (typeof value === "string") {
    const parsed = parseInt(value, 10)
    return Number.isNaN(parsed) ? undefined : parsed
  }
  return undefined
}

export const getMaterialFromColor = (color?: DropDownOptionValue) => {
  const normalizedColor = normalizeToNumber(color)
  if (normalizedColor === undefined) {
    return appConst.MATERIAL_FRAME
  }
  return normalizedColor === 0 ? appConst.MATERIAL_KAPPA : appConst.MATERIAL_FRAME
}

const SMALL_TILE_SCALE = 0.82

export const getTilePreviewSizes = (
  formatValue?: DropDownOptionValue,
  material?: number
) => {
  const format = normalizeToNumber(formatValue)
  const isKappa = material === appConst.MATERIAL_KAPPA

  switch (format) {
    case appConst.FRAME_SIZE_20X20:
      return {
        containerSize: `${SMALL_TILE_SCALE * 100}%`,
        imageSize: isKappa ? "93%" : "89%",
        frameSize: "100%",
      }
    case appConst.FRAME_SIZE_30X30:
      return {
        containerSize: "100%",
        imageSize: isKappa ? "92.5%" : "87%",
        frameSize: "100%",
      }
    default:
      return {
        containerSize: "100%",
        imageSize: "100%",
        frameSize: "100%",
      }
  }
}
